import { InjectionToken } from '@angular/core';

export type ApiVersion = 'v1' | 'v2';
export type ApiDomain = 'core' | 'fast';

export type ApiConfig = {
  apiUrl: Record<ApiDomain, string>;
  apiVersion: Record<ApiVersion, string>;
};

export const API_CONFIG = new InjectionToken<ApiConfig>('API_CONFIG');
